import Vue from "vue";
import Vuex from "vuex";
import router from "./router";
import Cookies from 'js-cookie';
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: JSON.parse(localStorage.getItem("isLoggedIn")) || false,
    userData: {},
    email: null,
    otp: null,
    snackbar: {
      visible: false,
      message: "",
      type: "success",
      duration: 2000,
      // questionsByType: {},
    },
    permissions: [], 
    lookupData: {}, 
    // create survey page
    isSurveycreated: false,
    isSurveyedited: false,
    uncheckedItems: [],
    allQuestionsUnchecked: [],
    addQuestionsUnchecked: [],
    allQuestionsRemoved: [],
    questionGroupLengths: {},
    // full question per tab
    domain1AllQuestions: [],
    domain2AllQuestions: [],
    domain3AllQuestions: [],
    descriptionAllQuestions: [],
    factTriviaAllQuestions: [],
    personalityAllQuestions: [],
    // checked question per tab
    generateQuestion: false,
    questionsByType: {}, //generated Q's
    questionsDataByTab: {}, //tabwise Q's
  },
  mutations: {
  
    SET_EMAIL(state, email) {
      state.email = email;
    },
    SET_OTP(state, otp) {
      state.otp = otp;
    },
    setUserData(state, payload) {
      state.userData = payload;
      localStorage.setItem("role", payload.name);
      localStorage.setItem("email", payload.email);
    },
    loginUser(state, payload) {
      state.isLoggedIn = true;
      state.userData = payload;
      localStorage.setItem("isLoggedIn", true); 

      const token = Cookies.get("token");
      if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    },
    logoutUser(state) {
      state.isLoggedIn = false;
      state.userData = {};
      state.lookupData = {};
      state.permissions = [];  // Clear permissions on logout
      Cookies.remove("token");
      delete axios.defaults.headers.common['Authorization'];
      localStorage.clear();
      router.push("/");
    },
    setLookupData(state, data) {
      state.lookupData = data;
    },
    showSnackbar(state, payload) {
      state.snackbar.visible = true;
      state.snackbar.message = payload.message;
      state.snackbar.type = payload.type || "success";
      state.snackbar.duration = payload.duration || 3000;
    },
    hideSnackbar(state) {
      state.snackbar.visible = false;
    }, 
    setSurveyCreated(state, value) { 
      state.isSurveycreated = value;
    },
    setSurveyEdited(state, value) { 
      state.isSurveyedited = value;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    }, 
    REMOVE_STORED_EMAIL_AND_OTP(state) {
      state.storedEmail = null;
      state.storedOTP = null;
    },
  //save data from generated Q's
    setQuestionsByType(state, { type, questions }) {
      state.questionsByType = {
        ...state.questionsByType, 
        [type]: questions,       
      };
    },
    //save data from each tab
    setQuestionsDataByTab(state, { tab, questionsData }) {
      state.questionsDataByTab = {
        ...state.questionsDataByTab,
        [tab]: questionsData,
      };
    },
    
    //update check status on tabdata
    
    setQuestionGroupLength(state, { group, length }) {
      Vue.set(state.questionGroupLengths, group, length); 
    },
    clearQuestionsData(state) {
      state.questionsByType = {}; 
      state.questionGroupLengths = {}; 
    },
    saveTabData(state, { type, data }) {
      switch (type) {
        case "Domain 1":
          state.domain1AllQuestions = data;
          break;
        case "Domain 2":
          state.domain2AllQuestions = data;
          break;
        case "Domain 3":
          state.domain3AllQuestions = data;
          break;
        case "Description":
          state.descriptionAllQuestions = data;
          break;
        case "Fact/Trivia":
          state.factTriviaAllQuestions = data;
          break;
        case "Personality":
          state.personalityAllQuestions = data;
          break;
        default:
          console.error(`Unknown tab type: ${type}`);
      }
    },
    ADD_QUESTION_TO_generatedlist(state, { domain, question }) {
      if (!state.questionsByType[domain]) {
        state.questionsByType[domain] = [];
      }
      state.questionsByType[domain].push(question);
    },
    setGenerateQuestion(state, value) {
      state.generateQuestion = value;
    },
    CLEAR_QUESTIONS_BY_TYPE(state) {
      for (const key in state.questionsByType) {
        state.questionsByType[key] = []; 
      }
    },
    updateIsCheckedInDomain(state, { questionId, isChecked }) {
    
      // Find the question by ID and update its isChecked value
      const question = state.domain1AllQuestions.find((q) => q.id === questionId);
      if (question) {
        question.isChecked = isChecked; // Update the isChecked value
      }
    },
    updateQuestionsByType(state, { tab, data }) {
      if (state.questionsByType[tab]) {
        state.questionsByType[tab] = data; // Update the questions for the current domain/tab
      }
    },
    setMismatchFlag(state, { tabName, isMismatch }) {
      Vue.set(state.mismatchFlags, tabName, isMismatch);  // Use Vue.set to ensure reactivity
    },
    // updateQuestionsDataByTab(state, { tab, data }) {
    //   state.questionsDataByTab[tab] = data;
    // },
  },
  actions: {
    setUserData({ commit }, userData) {
      commit("setUserData", userData);
    },
    logout({ commit }) {
      commit("logoutUser");
    },
    triggerSnackbar({ commit }, payload) {
      commit("showSnackbar", payload);
      setTimeout(() => {
        commit("hideSnackbar");
      }, payload.duration || 3000);
    },
    fetchLookupData({ commit }) {
      return axios({
        url: "/admins/lookup",
        method: "get",
      })
        .then((response) => {
          if (response.data.status === 200) {
            const lookupData=response.data.data;
            commit("setLookupData", lookupData); 
          } else {
            console.error("Error fetching lookup data:", response.data.message);
          }
        })
        .catch((error) => {
          console.error("API error:", error?.response?.data?.error);
        });
    },
    saveTabData({ commit }, payload) {
      commit("saveTabData", payload);
    },
    
    addQuestionToDomain({ commit }, { domain, question }) {
      commit("ADD_QUESTION_TO_generatedlist", { domain, question });
    },
    updateGenerateQuestion({ commit }, value) {
      commit('setGenerateQuestion', value);
    },
    clearQuestionsByType({ commit }) {
      commit("CLEAR_QUESTIONS_BY_TYPE");
    },
  },
  getters: {
  },
  plugins: [
    createPersistedState({
      paths: [
        'permissions',
        'lookupData',
        'email',
        'otp',
        'generateQuestion',
        'questionsByType', 
        'questionGroupLengths',
        'domain1AllQuestions',
        'domain2AllQuestions',
        'domain3AllQuestions',
        'descriptionAllQuestions',
        'factTriviaAllQuestions',
        'personalityAllQuestions',
      ],
    }),
  ],
  
  
});
